module.exports = __webpack_public_path__ + "static/media/breadcrumb_parent_logo.521f4056.png";